import {ApplicationInsights} from '@microsoft/applicationinsights-web';

/**
 * Extends the Microsoft Application Insights
 */
export class Analytics extends ApplicationInsights {
  /**
   * Extends the Microsoft Application Insights, adding our methods
   */
  constructor() {
    super({
      config: {
        instrumentationKey: '133dc952-acd0-4c0a-a716-18e854ceb214',
      },
    });

    this.loadAppInsights();
  }
}
